import React from "react";
import RSelect from "react-select";
import { StylesConfig } from "react-select/dist/declarations/src/styles";
import { DefaultOption, SelectProps } from "./types";
import { customDarkStyles, customStyles } from "./styles";
import styles from "./Select.module.scss";
import CreatableSelect from "react-select/creatable";

const Select = <T = DefaultOption,>(props: SelectProps<T>) => {
  const {
    options = [],
    loading,
    className = "",
    isCreatable,
    optionValue = "value",
    optionLabel = "label",
    required,
    selectRef,
    ...restProps
  } = props;

  const getLabel = (item: T): string => {
    if (typeof optionLabel === 'function') {
      return optionLabel(item);
    }
    return item[optionLabel as keyof T] as string;
  };

  const getValue = (item: T): string => {
    return item[optionValue as keyof T] as string;
  };

  const createOption = (valueData: string, labelData: string): T => {
    if (typeof optionLabel === 'function') {
      const obj: any = {
        [optionValue]: valueData,
        __isNew__: true,
      };
      return obj as T;
    } else {
      return {
        [optionValue]: valueData,
        [optionLabel as string]: labelData,
        __isNew__: true,
      } as T;
    }
  };

  const GeneralSelect = isCreatable ? CreatableSelect : RSelect;

  return (
    <GeneralSelect
      {...restProps}
      ref={selectRef}
      classNamePrefix="react-select"
      styles={customStyles as StylesConfig<T>}
      value={props.value}
      hideSelectedOptions={false}
      isMulti={props?.isMulti}
      isLoading={loading}
      getOptionLabel={(option) => getLabel(option)}
      getOptionValue={(option) => getValue(option)}
      options={options}
      className={`${styles.select__input} ${className}`}
      components={{
        IndicatorSeparator: () => null,
      }}
      getNewOptionData={(inputValue, inputLabel) =>
        createOption(inputValue, String(inputLabel || inputValue))
      }
    />
  );
};

export default Select;
